<!-- <div class="custombg fixed-top">
    <app-header #header></app-header>
    <app-breadcrumb></app-breadcrumb>
</div> -->
<div class="section_container">
    <div class="sub_section">
        <div class="sub_section_body">
            <div class="metrics_section">
                <img src="../../../../assets/images/c360_new/changes_new/Metrics 1.svg" width="100%" height="100%">
            </div>
        </div>
    </div>
    <div class="sub_section mt-2">
        <div class="sub_section_header">
            Accounts Needing Attention
        </div>
        <div class="sub_section_body">
            <div class="accounts_needing_section">
                <img src="../../../../assets/images/Accounts needing Attention.svg" width="100%" height="100%">
            </div>
            <div class="group_projects">
                <img src="../../../../assets/images/group_img.png" width="100%" height="315px">
                <div class="centene_logo">
                    <img src="../../../../assets/images/centene 1.png" width="100%" height="100%"
                        (click)="navigateToC360()">
                </div>
            </div>
        </div>
    </div>
</div>